import type { FunctionComponent } from 'react';

import { useActiveThreadStoreApi } from '../ActiveThreadStoreProvider';
import type { CommentsApi } from '../comments-api-context';
import type { CommentsSubject } from '../subject/comments-subject';
import type { CommentsGroupMemberRole } from './comments-group-member';
import { commentsGroupMemberIdFor } from './comments-group-member';
import { useRegisterCommentsGroupMember } from './use-comments-group-member';
import { useGroupThreadActivationBridge } from './use-group-thread-activation';
import { useScrollActivatedAnchorIntoView } from './use-scroll-activated-anchor';

// Mount inside the member tile's own ActiveThreadStoreProvider: it joins the group surface,
// mirrors group activation back into the tile so its rows highlight, and reveals the activated
// row. Anchor geometry is not published from here — the group comment tile's layout resolves
// every member's rows itself, straight from the DOM.
export const CommentsGroupMemberBinding: FunctionComponent<{
    readonly api: CommentsApi;
    readonly label: string;
    readonly memberRole: CommentsGroupMemberRole;
    readonly subject: CommentsSubject;
}> = ({ api, label, memberRole, subject }) => {
    const memberId = commentsGroupMemberIdFor(subject);
    const threadStore = useActiveThreadStoreApi();

    useRegisterCommentsGroupMember({ api, label, memberId, role: memberRole, subject, threadStore });
    useGroupThreadActivationBridge(memberId);
    useScrollActivatedAnchorIntoView(memberId);

    return null;
};
